// The app's full brand profile (BrandDashboard's ProfileTab): what the API
// can store, and what a save failure means. PUT /v3/brands/:id.
//
// The API used to drop companyName, address and iban without a word while
// the form said "Mentve." The current API stores them (brands.company_name /
// address / iban) and answers them on GET /v3/brands/:id; an older API does
// not, so the form feature-checks the read and never sends — or reports as
// saved — what the server would drop:
//   company_name in the read      -> companyName + address are stored
//   can_manage_billing in the read -> the IBAN is stored; false = this user
//                                     may not change it (manageBilling)
//   adminSuspended / admin_suspended -> Outfino suspended the brand: the
//                                     visibility switch cannot lift it
// `website` is never sent from here: the brand's web address is the
// Beállítások "A webshop címe" field (the embed key's site domain).

export function profileSupport(full) {
  const read = full && typeof full === 'object' ? full : null;
  return {
    profileFields: read ? 'company_name' in read : null,
    canManageBilling: read && 'can_manage_billing' in read ? read.can_manage_billing === true : null,
    suspended: !!read && (read.adminSuspended === true || read.admin_suspended === true),
  };
}

/// The i18n key for a failed save: the API's 400 / 403 details, else generic.
export function profileErrorKey(err) {
  const data = err?.data || {};
  const field = data.details?.field;
  if (err?.status === 400 && field === 'iban') return 'profile.err.iban';
  if (err?.status === 400 && (field === 'companyName' || field === 'address')) return `profile.err.${field}`;
  if (err?.status === 403 && data.details?.permission === 'manageBilling') return 'profile.err.ibanPermission';
  if (err?.status === 403 && data.message === 'admin_only_field') return 'profile.err.adminOnly';
  return 'profile.saveError';
}

/// IBAN as typed -> as the API stores it (for the "changed?" check only; the API normalises too).
export function normalizeIbanInput(value) {
  return String(value ?? '').replace(/[\s -]/g, '').toUpperCase();
}
